<template>
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <path d="M13.7136 4.92001C13.6116 4.81334 13.484 4.80002 13.3565 4.80002H10.6782V3.20002C10.6782 2.90669 10.4232 2.66669 10.1426 2.66669H5.85735C5.57677 2.66669 5.32171 2.90669 5.32171 3.20002V4.80002H2.64345C2.36287 4.80002 2.1333 4.97335 2.1333 5.26669V12.8C2.1333 13.0934 2.36287 13.3334 2.64345 13.3334H13.3565C13.6371 13.3334 13.8666 13.0934 13.8666 12.8V5.29335C13.8666 5.14668 13.8156 5.02667 13.7136 4.92001ZM6.342 3.73335H9.65794V4.80002H6.342V3.73335ZM12.8463 5.86669V8.66669H9.27533V8.46669C9.27533 8.24002 9.07127 8.13335 8.85445 8.13335H7.13272C6.9159 8.13335 6.71185 8.25335 6.71185 8.46669V8.66669H3.14084V5.86669H12.8463ZM8.51011 8.93335V9.20002H7.48982V8.93335H8.51011ZM3.15359 12.2667V9.46669H6.72461V9.60002C6.72461 9.82669 6.92867 10 7.14548 10H8.86722C9.08403 10 9.28808 9.81335 9.28808 9.60002V9.46669H12.8591V12.2667H3.15359Z" fill="#00527F"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "smallThingIcon"
}
</script>

<style scoped>

</style>
